import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import { useServerClock } from '../hooks/useServerClock'

// The deployed build's semver, next to the logo. Like EnvBadge it comes from
// GET /api/time (the Worker's APP_VERSION, set by _deploy.yml) rather than a
// build-time value, so both SPAs -- and the same bundle wherever it runs --
// report the version of the API they are actually talking to. Semver build
// metadata (+sha) stays out of the header but is in the tooltip.
export function VersionLabel() {
  const { appVersion, synced } = useServerClock()

  if (!synced) return null

  const label = appVersion === 'dev' ? 'dev' : `v${appVersion.split('+')[0]}`

  return (
    <Tooltip title={appVersion}>
      <Typography variant="caption" component="span" sx={{ fontSize: '0.65rem', opacity: 0.8, whiteSpace: 'nowrap' }}>
        {label}
      </Typography>
    </Tooltip>
  )
}
